import { useEffect } from "react";

import {
  AgentsIcon,
  Button,
  ButtonGroup,
  Column,
  Dialog,
  Text,
} from "@hightouch/htui";

import { useShouldShowAiFeaturesAnnouncement } from "src/hooks/use-should-show-ai-features-announcement";
import * as analytics from "src/lib/analytics";
import { LinkButton } from "src/router";

export const AiFeaturesAnnouncementDialog = () => {
  const { shouldShow, isAdmin, setIsDismissed } =
    useShouldShowAiFeaturesAnnouncement();

  const onDismiss = () => {
    setIsDismissed(true);
    analytics.track("AI Features Announcement Dismissed", { isAdmin });
  };

  const onClickManage = () => {
    setIsDismissed(true);
    analytics.track("AI Features Announcement Manage Clicked", { isAdmin });
  };

  useEffect(() => {
    if (!shouldShow) return;
    analytics.track("AI Features Announcement Shown", { isAdmin });
  }, [shouldShow, isAdmin]);

  if (!shouldShow) return null;

  return (
    <Dialog
      isOpen
      variant="form"
      width="sm"
      title="AI features are on by default"
      headerIcon={<AgentsIcon />}
      onClose={onDismiss}
      actions={
        <ButtonGroup>
          {isAdmin && (
            <LinkButton
              href="/organization/ai-features"
              onClick={onClickManage}
            >
              Manage AI features
            </LinkButton>
          )}
          <Button variant="primary" onClick={onDismiss}>
            Got it
          </Button>
        </ButtonGroup>
      }
    >
      <Column gap={3}>
        <Text color="text.secondary">
          We&apos;ve updated how AI features roll out in Hightouch. New features
          are now on by default for everyone in your organization.
        </Text>
        <Text color="text.secondary">
          {isAdmin
            ? "You can choose which ones are available at any time."
            : "If you'd like to change which AI features are available, reach out to your org admin."}
        </Text>
      </Column>
    </Dialog>
  );
};
